import script from "./Clock.vue?vue&type=script&setup=true&lang=js"
export * from "./Clock.vue?vue&type=script&setup=true&lang=js"

import "./Clock.vue?vue&type=style&index=0&id=17078f52&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17078f52"]])

export default __exports__